import React from 'react';
import { Box, Card, CardContent, Typography, Skeleton, Tooltip, IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoIcon from '@mui/icons-material/Info';
import { MetricCardProps } from 'src/types/analytics';

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  change,
  subtitle,
  tooltipText,
  loading = false
}) => {
  const isPositiveChange = change && change > 0;

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="subtitle2" color="text.secondary">
            {title}
          </Typography>
          {icon && (
            <Box color="primary.main">
              {icon}
            </Box>
          )}
        </Box>

        {loading ? (
          <Skeleton variant="rectangular" width="60%" height={42} />
        ) : (
          <Typography variant="h4" component="div" fontWeight="bold">
            {value}
          </Typography>
        )}

        {change !== undefined && !loading && (
          <Box display="flex" alignItems="center" mt={1}>
            {isPositiveChange ? (
              <ArrowUpwardIcon fontSize="small" color="success" />
            ) : (
              <ArrowDownwardIcon fontSize="small" color="error" />
            )}
            <Typography
              variant="body2"
              color={isPositiveChange ? 'success.main' : 'error.main'}
              ml={0.5}
            >
              {Math.abs(change)}%
            </Typography>
          </Box>
        )}

        {subtitle && !loading && (
          <Box display="flex" alignItems="center" mt={1}>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
            {tooltipText && (
              <Tooltip title={tooltipText} arrow placement="top">
                <IconButton size="small" sx={{ p: 0.5, ml: 0.5 }}>
                  <InfoIcon fontSize="small" color="action" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}
        {tooltipText && !subtitle && (
          <Box display="flex" width="100%" justifyContent="end">
            <Tooltip title={tooltipText} arrow placement="top">
              <IconButton size="small" sx={{ p: 0.5, ml: 0.5 }}>
                <InfoIcon fontSize="small" color="action" />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard; 